var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { OfficeAppHosted } from '@office-start/office-home-app';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { ReactQueryDevtools } from 'react-query-devtools';
export var renderAppHosted = function (appContext) {
    var _a, _b, _c, _d, _e;
    if (!appContext) {
        console.error('No app context provided in production.');
    }
    // Inject other missing properties from OfficeReactStartupConfiguration that are expected to be on the context
    // When this moves into office-home-app, we can merge this with other configs to fully populate it
    // (or move it into some other type to make more sense from a client perspective)
    if (!appContext.wrapperVersion && (window === null || window === void 0 ? void 0 : window.Windows)) {
        appContext = __assign(__assign({}, appContext), { wrapperVersion: (_e = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.Windows) === null || _a === void 0 ? void 0 : _a.ApplicationModel) === null || _b === void 0 ? void 0 : _b.Package) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.version });
    }
    ReactDOM.render(_jsxs(_Fragment, { children: [_jsx(StrictMode, { children: _jsx(OfficeAppHosted, __assign({}, appContext)) }), _jsx(ReactQueryDevtools, { initialIsOpen: false })] }), document.getElementById('root'));
};
